import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase';
import {SplitText} from 'gsap/SplitText';
gsap.registerPlugin( ScrollTrigger, CustomEase, SplitText );
( function( app ) {
  const COMPONENT = {
    init: function() {
      const _this = this;
    },
    finalize: function() {
    },
    animate: function() {
      function createAnimation( elements, startAnimationObj, animationFunction, start = 'top 90%' ) {
        if ( window.hasMotion ) {
          if ( ( typeof elements === 'string' && document.querySelectorAll( elements ).length > 0 ) || ( typeof elements === 'object' && elements.length > 0 ) ) {
            gsap.set( elements, startAnimationObj );
            const triggers = ScrollTrigger.batch( elements, {
              toggleClass: 'js-animated',
              once: true,
              start: start,
              onEnter: ( batch ) => {
                animationFunction( batch );
              },
            } );

            ScrollTrigger.addEventListener( 'refreshInit', () => {
              triggers.forEach( ( trigger ) => {
                if ( trigger.progress > 0 ) {
                  animationFunction( trigger.trigger );
                }
              } );
            } );
          }
        }
      }

      // global animations in animate will load in after running common.js init function, all component javascript, and before common.js finalize function.
      // This should improve animations loading in and fix odd start times due to load order
      /*
       * Fade on scroll
       */
      const fadeUpClasses = '.js-fade:not(.js-ignore), .js-fade-group > *:not(.js-ignore)';
      function fadeUpTimeline( elements ) {
        const tl = gsap.timeline();
        /*
          * The following .to functions are the equivalent of
          * transition: opacity 0.35s ease 0.1s, transform 1s ease-out 0.1s;
          */

        /* Opacity style and transitions */
        tl.to( elements, {
          autoAlpha: 1, // property/value
          duration: 0.35, // duration e.g. 0.35s
          ease: '0.25,0.1,0.25,1', // timing function e.g. ease
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );

        /* Transform style and transitions */
        tl.to( elements, {
          y: 0, // property/value
          duration: 1, // duration e.g. 1s
          ease: '0, 0, 0.58, 1.0', // timing function eg. ease-out
          stagger: 0.1, // delay e.g 0.1s
        }, 0 );
      }
      createAnimation( fadeUpClasses, {autoAlpha: 0, y: 25}, fadeUpTimeline );

      /*
       * Reveal on scroll
       */
      function reveal( elements ) {
        gsap.to( elements,
            {
              clipPath: 'inset(0% 0% 0% 0%)',
              duration: 1.5,
              ease: '0, 0, 0.58, 1.0',
              stagger: 0.2, // delay e.g 0.2s
            },
        );
      }

      const revealRightClasses = '.js-reveal-right:not(.js-ignore)';
      createAnimation( revealRightClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      const revealLeftClasses = '.js-reveal-left:not(.js-ignore)';
      createAnimation( revealLeftClasses, {clipPath: 'inset(0 0 0 100%)'}, reveal );

      const drawLineClasses = '.js-draw-line:not(.js-ignore)';
      createAnimation( drawLineClasses, {clipPath: 'inset(0 100% 0 0)'}, reveal );

      /* Just needed to add js-animated - all animation is done in css */
      const drawBorderClasses = '.js-border:not(.js-ignore)';
      createAnimation( drawBorderClasses, {}, function() {} );

      if ( window.hasMotion ) {
        new SplitText( '.js-slide-group > [class*="hdg-"], [class*="hdg-"].js-slide', {type: 'lines', linesClass: 'line-wrap', tag: 'span'} );
        new SplitText( '.line-wrap', {type: 'lines', linesClass: 'line', tag: 'span'} );

        document.querySelectorAll( 'section' ).forEach( ( el ) => {
          const section = gsap.utils.selector( el );
          const sectArray = section( '.js-slide:not(.js-ignore, [class*=hdg-]), .js-slide-group > *:not(.js-ignore, [class*=hdg-]), .line, .js-fade, .js-slide-group-slow > *:not(.js-ignore, [class*=hdg-])' );

          const items = sectArray;
          if ( items.length > 0 ) {
            el.style.setProperty( '--item-total', items.length );
            sectArray.map( ( line, index ) => line.style.setProperty( '--item-index', index ) );
          }
        } );

        /*
          * Fade on scroll
          */
        $( '.js-slide:not(.js-ignore), .js-slide-group > *:not(.js-ignore)' ).each( function( index, element ) {
          ScrollTrigger.create( {
            trigger: this,
            start: 'top 100%',
            scrub: 0.10,
            // markers: true,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'js-animated' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'js-animated' ),
          } );
        } );
      }
    },
    onError: function() {
      document.querySelectorAll( '.js-fade, .js-slide-group > *, .js-slide, .js-slide-group > *' )?.forEach( ( el ) => {
        el.classList.add( 'js-show' );
      } );
    },
  };
  app.registerComponent( 'animations', COMPONENT );
} )( app );
